import Index from "@frog/source/models/App.js"
import Audiomix from "@frog/source/models/juice/Audiomix.js"

import encounters from "@frog/source/data/encounters.js"
// import tests from "@frog/source/tests/_.js" // TODO: lazy load this and all other imports to this file

class UserError extends Error {}

const Navigation = new class {
    constructor() {
        this.routes = []
        this.state = {"screen": "SplashScreen"}
    }
    go(path) {
        // this.state = state
        // TODO: Make this change the url & url history
        window.location.hash = path
        // TODO: is there anyway for us to directly call load from here
        // without an infinite loop of setting and refreshing but also
        // preserving the existing state we already have but also allowing
        // to default the state for true niave url loads?
    }
    goBack() {
        window.location.hash = ""
    }
    load(path) {
        path = path[0] == "#" ? path.substring(1) : path
        // path = "/" + path
        // console.log("Routing", path)
        this.request = {
            "path": path,
        }
        for(let index in this.routes) {
            const route = this.routes[index]
            // console.log(request.path, "->", route.path)
            if(this.request.path.match(route.path)) {
                try {
                    const state = route.func(this.request)
                    if(state != undefined) {
                        return this.state = state
                    }
                } catch(error) {
                    this.request.error = error

                    if(error instanceof UserError) {
                        this.state = this.onUserError(this.request)
                    } else { // if(error instanceof Error) {
                        this.state = this.onError(this.request)
                    }

                    throw error
                }
            }
        }
    }
    on(path, func) {
        if(path instanceof Error) {
            this.routes[path] = {path, func}
            return
        }
        if(path instanceof RegExp != true) {
            path = path.replace(/\*/g, "(.*)")
            path = new RegExp("^" + path + "$", "i")
        }
        this.routes.push({path, func})
    }
}

export default Navigation

Navigation.on("/", function(request) {
    return {"screen": "SplashScreen"}
    // TODO: if first time, play animations for splashing
})

Navigation.on("/credits", function(request) {
    Audiomix.trigger("Victory:Final")
    return {"screen": "CreditsScreen", "isTransitioning": true}
    // return {"screen": "CreditsScreen"}
})

Navigation.on("/game", function(request) {
    if(Index.game == undefined) {
        // console.log("Creating game")
        Index.load({
            "game": {
                "encounter": {}
            },
        })
        // TODO: Run any on-new-game scripting, music, etc.
        // TODO: Move this into an express-style middleware!!
    }
    return {"screen": "OverworldScreen"}
})

Navigation.on("/game/encounters/*", function(request) {
    const slug = request.path.split("/").pop() // TODO: support RegExp wildcards??

    if(Index.game == undefined) {
        // console.log("Creating game")
        Index.load({
            "game": {
                "encounter": {}
            },
        })
        // TODO: Move this into an express-style middleware!!
    }
    if(encounters[slug] == undefined) {
        throw new UserError("Could not find encounter " + slug)
    }

    // TODO: Load this dev state from your friendly json payload.
    // const app = require("@frog/source/data/devstate.js")

    if(Index.game.encounter == undefined
    || Index.game.encounter.slug != slug) {
        // console.log("Creating encounter", slug)
        Index.load({
            "game": {
                "encounter": encounters[slug]
                // TODO: let references be
            }
        })
        // Index.game.encounter = CombatEncounter.load(encounters[slug])
    }

    return {"screen": "EncounterScreen"}
})

Navigation.on("/dev/tests", function(request) {
    return {"screen": "SplashScreen", "devscreen": "TestListScreen"}
})

Navigation.on("/dev/tests/*", function(request) {
    const slug = request.path.substring(11) // TODO: support RegExp wildcards??
    // import("@frog/source/tests/_.js").then((tests) => {tests = tests.default
    // console.log("Loading test", slug)
    const test = tests.find((test) => test.slug == slug)
    if(test == undefined) {
        throw new UserError("Could not find test " + slug)
    }
    if(test.snapshot == undefined) {
        throw new UserError("Could not find snapshot for test " + slug)
    }
    Index.loadTest(test)
    return {"screen": "EncounterScreen", "devscreen": "TestListScreen", "testslug": slug}
})

Navigation.on("/*", function(request) {
    throw new UserError("Could not find " + request.path)
})

Navigation.onUserError = function(request) {
    return {"screen": "ErrorScreen", "message": request.error.message}
}
Navigation.onError = function(request) {
    return {"screen": "ErrorScreen", "message": "Something went wrong!!"}
}

if(typeof window != "undefined") {
    Navigation.load(window.location.hash)
    window.addEventListener("hashchange", () => {
        Navigation.load(window.location.hash)
    })
}

// SPLASH SCREEN

// // TODO: centralize this along with the view navigation
// // const isExplicitlyTesting = params.get("test") != null
// // if(isExplicitlyTesting == true) {
// //     window.frog.test.log()
// // }
// window.frog.test.log()
// window.frog.navigation = {"screen": "TestListScreen"}
